// todo move all to view controls
export enum CameraTypeEnum {
    PERSPECTIVE = "perspective",
    ORTHO = "ortho",
    STEREO = "stereo",
    WEBVR = "webVR"
}

export enum MouseActionEnum  {
    ROTATE = 0,
    PAN = 1
}

export enum EViewControls {
    ABSTARACT = "",
    EXAMINER = "examiner",
    EXAMINER_STEREO = "examinerStereo",
    EXAMINER_WEBVR = "examinerWebVR",
    WALK = "walk",
    WALK_STEREO = "walkStereo",
    WALK_WEBVR = "walkWebVR",
    FLY = "fly",
    FLY_STEREO = "flyStereo",
    FLY_WEBVR = "flyWebVR",
    YANIMATION = "yanim",
    FILE_ANIMATION = "fileAnim",
    FILE_ANIMATION_STEREO = "fileAnimStereo",
    FILE_ANIMATION_WEBVR = "fileAnimWebVR"
}

export enum EViewControlsFamily {
    ABSTARACT = "",
    EXAMINER = "examiner",
    WALK = "walk",
    FLY = "fly",
    YANIMATION = "yanim",
    FILE_ANIMATION = "fileAnim"
}
